import React, { Component } from 'react'
import { Box, /*Tab, Tabs,*/ Anchor } from 'grommet';

export default class MenuDispute extends Component {
    render() {
        return (
            <Box basis='auto' direction='row' pad='medium' style={{ borderBottom: '1px solid #c3c3c3', marginBottom: '20px' }}>
                <Anchor className='navbar' style={{ width: '50%' }} href='/Dispute/GestioneRichieste'>Gestione Dispute</Anchor>
                <Anchor className='navbar' style={{ width: '50%' }} href='/Dispute/Report'>Report</Anchor>
            </Box>
        )
    }
}
